export const EDITOR_ACTION = {
  OPEN_UNIFIED_MANAGER_PANEL: 'openUnifiedManagerPanel',
  OPEN_SETTINGS_PAGE_UNIFIED_MANAGER_PANEL:
    'openSettingsPageUnifiedManagerPanel',
} as const;
